import React, { useState } from 'react';
import PropTypes from 'prop-types';

/** import Material UI */
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';

import makeStyles from '@material-ui/core/styles/makeStyles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import DeviceHistoryListItem from './device-history-list-item';

const useStyles = makeStyles(() => ({
  hideIcon: {
    visibility: 'hidden'
  }
}));

const DeviceHistoryList = (props) => {
  const [expandedIdx, setExpandedIdx] = useState(-1);
  const classes = useStyles();

  const handleExpandDevice = (idx) => {
    if (expandedIdx === idx) {
      setExpandedIdx(-1);
    } else {
      setExpandedIdx(idx);
    }
  };

  const listHeaderSummary = () => {
    const txtList = [{txt: 'UUID', width: 40}, {txt: 'Current Status', width: 30}, {txt: 'Last Update Time', width: 30}];
    return (
      <ExpansionPanel expanded={false}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{ expandIcon: classes.hideIcon }}>
          {
            txtList.map(({ txt, width }, idx) => {
              return (
                <Typography key={idx} 
                  style={{ flexBasis: `${width}%`, fontSize: 12, color: 'rgba(0, 0, 0, 0.54)', textAlign: 'center' }}
                >
                  {txt}
                </Typography>
              );
            })
          }
        </ExpansionPanelSummary>
      </ExpansionPanel>
    );
  };

  return (
    <div className='deviceList'>
      {listHeaderSummary()}
      <div className='body'>
        {
          props.devices.map((item, idx) => {
            return (
              <DeviceHistoryListItem key={idx} {...item} expanded={expandedIdx === idx} handleExpandDevice={handleExpandDevice} idx={idx}/>
            );
          })
        }
      </div>
    </div>
  );

};

DeviceHistoryList.propTypes = {
  devices: PropTypes.array.isRequired
};

export default React.memo(DeviceHistoryList);